// extracted by mini-css-extract-plugin
export var inputs = "ManualInputs-module--inputs--F0iFn";
export var root = "ManualInputs-module--root--zqqAO";